import { useMutation, useQueryClient } from "@tanstack/react-query";
import { patchJobAction } from "../../../clients/actions/patchJob.action";
import { useGlobalSnackbar } from "src/context/SnackbarContext";

export function usePatchJobScopeOfWork() {
  const { showSnackbar } = useGlobalSnackbar();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: {
      jobId: string | number;
      payload: Record<string, unknown>;
      alias?: string;
      description?: string;
    }) =>
      patchJobAction(variables.jobId, {
        scopeOfWork: variables.payload,
        ...(variables.alias !== undefined ? { alias: variables.alias } : {}),
        ...(variables.description !== undefined ? { description: variables.description } : {}),
      }),
    onSuccess: (_data, variables) => {
      showSnackbar("Scope of work updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["jobs"] });
      queryClient.invalidateQueries({ queryKey: ["job"] });
      queryClient.refetchQueries({ queryKey: ["job", String(variables.jobId)] });
      queryClient.invalidateQueries({ queryKey: ["scopeOfWork"] });
    },
    onError: (error: any) => {
      showSnackbar(error?.response?.data?.message || "Failed to update scope of work", "error");
    },
  });
}
